import { LIBIDA_PQP_PLAN_SELECTOR_VARIANT } from "~/constants/flags";
import { isLibidaPlanSelectorTreatment } from "~/lib/featureFlags/isLibidaPlanSelectorTreatment";

import { useFlagDecision } from "./useFlag";

export const useLibidaDiscountBadgeVisibility = (): boolean => {
    const { value: planSelectorVariation, isDecided } = useFlagDecision(
        LIBIDA_PQP_PLAN_SELECTOR_VARIANT
    );

    return (
        isDecided && !isLibidaPlanSelectorTreatment(planSelectorVariation)
    );
};
